import { MAP_ICON_URL } from '@/constants/icons';
import type { MachineInfo } from '@/services/dto';
import type { PoiItem } from '@/types/map';
import type { IMarkerOption } from 'dabeeomaps';

export const mapPoiToMarker = (
    poiItem?: PoiItem,
    iconSize: { width: number; height: number } = { width: 35, height: 48 },
    iconUrl?: string
): IMarkerOption | undefined => {
    if (!poiItem) {
        return undefined;
    }
    return {
        x: poiItem?.position?.x,
        y: poiItem?.position?.y,
        floorId: poiItem?.floorId,
        fixedSize: true,
        iconOption: {
            width: iconSize?.width,
            height: iconSize?.height,
            anchor: {
                x: 0.5,
                y: -0.15,
            },
            iconUrl: iconUrl || MAP_ICON_URL.POSITION_MARKER_ICON,
        },
    };
};

export const mapPoiListToMarker = (
    poiList?: PoiItem[],
    iconSize: { width: number; height: number } = { width: 35, height: 48 },
    iconUrl?: string
): IMarkerOption[] => {
    if (!Array.isArray(poiList) || !poiList?.length) {
        return [];
    }

    const result: IMarkerOption[] = poiList.map((poi) => ({
        x: poi?.position?.x,
        y: poi?.position?.y,
        fixedSize: true,
        floorId: poi?.floorId,
        iconOption: {
            width: iconSize?.width,
            height: iconSize?.height,
            anchor: {
                x: 0.5,
                y: -0.15,
            },
            iconUrl: iconUrl || MAP_ICON_URL.DESTINATION_POINT_ICON,
        },
    }));

    return result;
};

export const mapMyLocationToMarker = (
    floorId?: string,
    myLocation?: MachineInfo,
    iconSize: { width: number; height: number } = { width: 35, height: 48 }
): IMarkerOption | undefined => {
    if (!myLocation) {
        return undefined;
    }
    return {
        x: myLocation?.positionX,
        y: myLocation?.positionY,
        floorId,
        fixedSize: true,
        iconOption: {
            width: iconSize?.width,
            height: iconSize?.height,
            anchor: {
                x: 0.5,
                y: 0.55,
            },
            iconUrl: MAP_ICON_URL.CURRENT_LOCATION_ICON,
        },
    };
};
